import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getCompanyUsers } from "../../../SuperAdmin/CreateCompany/CompanyUser/Store/Thunk";
import { useDispatch, useSelector } from "react-redux";
import { companyUserEnum, GetKeyByValue } from "../../../../Helpers/EnumHelper";
import { SetSquads } from "../Store";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import IconSvg from "../../../SharedComponents/IconSvg";

export default function Squads() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const user = useSelector((state) => state.auth.user);
  const companyId = user.companyUser?.company?.companyId;
  const companyUserList = useSelector((state) => state.companyUser.companyUserList);
  const squads = useSelector((state) => state.squads.squadList);

  useEffect(() => {
    if (companyId && !companyUserList) {
      dispatch(getCompanyUsers({ companyId })).then((response) => {
        if (response?.payload) {
          const groupedArray = Object.entries(
            response.payload.reduce((acc, user) => {
              if (!acc[user.companyUserTypeEnum]) {
                acc[user.companyUserTypeEnum] = [];
              }
              acc[user.companyUserTypeEnum].push(user);
              return acc;
            }, {})
          ).map(([key, value]) => ({
            companyUserTypeEnum: key,
            users: value,
          }));
          dispatch(SetSquads(groupedArray));
        }
      });
    }
  }, [companyId, companyUserList, dispatch]);

  // helper to chunk an array into subarrays of length "chunkSize"
  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  return (
    <div className="text-14 fw-medium text-color-gray-light">
      <Row className="mb-2">
        <Col xs={"auto"}>{t("teams")}</Col>
      </Row>

      <Row>
        {squads?.map((squad, squadIndex) => {
          const userChunks = chunkArray(squad.users, 99);

          return userChunks.map((chunk, chunkIndex) => (
            <Col key={`${squadIndex}-${chunkIndex}`} xs={12} sm={6} lg={4} xxl={3} className={"pb-4"}>
              <div className="default-card px-3 pt-2 pb-3 h-100">
                <div className="mb-2">{t(GetKeyByValue(Number(squad.companyUserTypeEnum), companyUserEnum))}</div>

                {chunk.map((companyUser, userIndex) => (
                  <Row
                    key={`${squadIndex}-${chunkIndex}-${userIndex}`}
                    className="text-16 text-color-gray-dark flex-nowrap"
                  >
                    <Col xs={"auto"} className="align-content-center">
                      <IconSvg icon={"succes-dot"} fill={"#000000"} height={10} width={10} />
                    </Col>
                    <Col xs={"auto"} className="px-0 text-nowrap">
                      {companyUser.name}
                    </Col>
                  </Row>
                ))}
              </div>
            </Col>
          ));
        })}
      </Row>
    </div>
  );
}
